import { Builder } from '@builder.io/sdk';
import IconCardRow from './IconCardRow';
import { IconCardInputs } from '../IconCard/IconCard.registry';

const IconCardRowConfig = {
  name: 'IconCardRow',
  friendlyName: 'Icon Card Row',
  inputs: [
    {
      name: 'items',
      type: 'list',
      subFields: [...IconCardInputs],
    },
  ],
};

Builder.registerComponent(IconCardRow, IconCardRowConfig);
